import { PaletteMode, ThemeOptions } from '@mui/material';

export const getColorTheme = (mode: PaletteMode): ThemeOptions => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // palette values for light mode
          primary: {
            main: '#357E8B',
          },
          secondary: {
            main: '#F7B41A',
          },
          error: {
            main: '#EA656F',
          },
          warning: {
            main: '#F7B41A',
          },
          info: {
            main: '#2196F3',
          },
          success: {
            main: '#4CAF50',
          },
          divider: 'rgba(53,126,139,0.2)',
          background: {
            default: '#FAFAFA',
            paper: '#FFF',
          },
          action: {
            focus: 'rgba(53,126,139,0.2)',
          },
        }
      : {
          // palette values for dark mode
          primary: {
            main: '#357E8B',
          },
          secondary: {
            main: '#F7B41A',
          },
          error: {
            main: '#EA656F',
          },
          warning: {
            main: '#F7B41A',
          },
          info: {
            main: '#2196F3',
          },
          success: {
            main: '#4CAF50',
          },
          divider: 'rgba(53,126,139,0.2)',
          background: {
            default: '#303030',
            paper: '#424242',
          },
          action: {
            focus: 'rgba(53,126,139,0.2)',
          },
        }),
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        inputMultiline: {
          resize: 'vertical',
        },
      },
    },
  },
});

export const customColors = {
  primary: {
    main: '53, 126, 139',
    light: '93, 151, 162',
    dark: '37, 88, 97',
    contrastText: '255, 255, 255',
  } as const,
};
